module.exports = __webpack_public_path__ + "img/PN.2f744e43.svg";